import { render, staticRenderFns } from "./CommentBox.vue?vue&type=template&id=496cf8d2&scoped=true&"
import script from "./CommentBox.vue?vue&type=script&lang=js&"
export * from "./CommentBox.vue?vue&type=script&lang=js&"
import style0 from "./CommentBox.vue?vue&type=style&index=0&id=496cf8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496cf8d2",
  null
  
)

export default component.exports